import styled from "@emotion/styled";
import { darkOrange } from "@stepfinance/react";
import type { FC, ReactNode } from "react";

import { ReactComponent as WarnIcon } from "../../assets/notifications/warnIcon.svg";

type SwapAlertProps = {
  messageText: ReactNode;
  smallerAmountText: string;
};

export const SwapAlert: FC<SwapAlertProps> = ({ messageText, smallerAmountText }) => {
  return (
    <SwapAlertBox>
      <IconContainer>
        <WarnIcon />
      </IconContainer>
      <AlertContentContainer>
        <strong>{messageText}</strong>
        <span>{smallerAmountText}</span>
      </AlertContentContainer>
    </SwapAlertBox>
  );
};

const AlertContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const IconContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    path {
      fill: white;
    }
  }
`;

const SwapAlertBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  padding: 9px 16px;
  margin-bottom: 20px;

  background-color: ${darkOrange};
  border-radius: 8px;
  color: white;
`;
